import React, { memo } from 'react';
import cn from 'classnames';

import { dateFormattingBreadcrumbs } from '@utils/kpi-utils/date';

import { IDateBreadcrumbsTypes } from './DateBreadcrumbs.types';

import { TTimeAggregationTypes } from '@enums/common';

import { timezoneUTC } from '@constants/common';
import { listOfTimeAggregationTypes } from '@constants/KPI/kpi-common';

import './DateBreadcrumbs.scss';

const DateBreadcrumbs = ({
	defaultIndexTimeAggregationType,
	currentIndexTimeAggregationType,
	date,
	isMultiDays,
}: IDateBreadcrumbsTypes) => {
	const breadcrumbs: Array<TTimeAggregationTypes> = listOfTimeAggregationTypes
		.slice(currentIndexTimeAggregationType, defaultIndexTimeAggregationType + 1)
		.reverse();
	// chart get from drill down
	const isDrilled = breadcrumbs.length > 1;

	return (
		<div className='f5gDateBreadcrumbsContainer'>
			{breadcrumbs.map((timeAggregationType, index) => {
				const isSelected
					= listOfTimeAggregationTypes.indexOf(timeAggregationType) === currentIndexTimeAggregationType;

				return (
					<div
						key={index + timeAggregationType}
						className={cn('f5gDateBreadcrumbsDateText', { 'f5gDateBreadcrumbsSelectedDateText': isSelected })}
						data-testid='breadcrumb'
					>
						<span data-testid='breadcrumb-label'>{timeAggregationType} {!isSelected && ' / '}</span>
						{isSelected && date
							&& <div className='f5gDateBreadcrumbsDate'>
								{dateFormattingBreadcrumbs({
									date,
									timeAggregationType,
									organizationTimezone: timezoneUTC,
									isMultiDays,
									isDrilled,
								})}
							</div>
						}
					</div>
				);
			})}
		</div>
	);
};

export default memo(DateBreadcrumbs);
